import { AirLock, Equipment, EquipmentType, Extractor } from "@/models/equipment.model";
import { Component, Prop, Vue } from "vue-property-decorator";
import EquipmentDetails from "../../../../../EquipmentDetails/index.vue";
@Component({
  components: {
    EquipmentDetails,
  },
})
export default class EquipmentListItem extends Vue {
  @Prop() equipmentType!: EquipmentType;
  @Prop() equipment!: AirLock | Extractor | Equipment;
  @Prop() categoryTitle!: string;

  selectEquipment(): void {
    this.$emit("equipmentSelected", this.equipment);
  }

  get isPhone(): boolean {
    return !this.$screen.md;
  }
}
